<template>
  <div>
    <ul class="language-list">
      <li v-for="(item, key) in languages" :key="key">
        <div>
          <input
            @change="change"
            :id="`lang-${name}-${key}`"
            :value="key"
            :name="`lang-${name}`"
            :checked="value == key"
            type="radio"
          />
          <label :style="{zIndex:key}" :for="`lang-${name}-${key}`">
            {{ key }}
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import { mapState } from "vuex";

export default {

  data: () => ({
    val:null
  }),
  props:{
    value:{
      default:function(){
        return 'ru'
      }
    },
    name:{
      default:''
    }
  },
  created(){
    if (this.languages_length && !this.languages[this.value]){
          this.$emit("input", Object.keys(this.languages)[0]);
    }
  },
  methods: {
    change(e) {
      this.$emit("input", e.target.value);
    },
  },
  computed: {
    ...mapState(["languages"]),
    languages_length:{
      get(){

          return Object.keys(this.languages).length;
      }
    }
  },
  watch:{
    languages_length(val){
        if (!this.languages[this.value] && val){
              this.$emit("input", Object.keys(this.languages)[0]);
        }
    }
  }
};
</script>

